import { useState, useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { LegalContentType } from '@/screens/residents/legal/LegalScreen';

interface UseLegalContentReturn {
  showLegalContent: (contentType: LegalContentType) => void;
  modalVisible: boolean;
  modalContentType: LegalContentType;
  closeModal: () => void;
}

export const useLegalContent = (): UseLegalContentReturn => {
  const navigation = useNavigation<any>();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContentType, setModalContentType] = useState<LegalContentType>('privacy');

  const showLegalContent = useCallback((contentType: LegalContentType) => {
    // Navigate to the dedicated Legal screen on all platforms
    setModalContentType(contentType);
    setModalVisible(false);
    navigation.navigate('Legal', { contentType });
  }, [navigation]);

  const closeModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  return {
    showLegalContent,
    modalVisible,
    modalContentType,
    closeModal,
  };
};
